import React from 'react';
import {
  ProgressBarItem,
  ProgressBarContainer,
  ProgressBarMobileContainer,
  MobileSideBadgesContainer,
  MobileSideBadgeImages,
  MobileProgressSeparator,
  BadgeTopButtonMobile,
  BadgeBottomTextMobile,
  BadgeItemContainerMobile,
  BigBadgeRewardContainer,
  GiftBadgeItemMobile, GiftIconMobile, GiftDescriptionMobile
} from './ProgressBarMobileStyle';
import { IContent } from '../../../../types';
import { withContent } from '../../../../hoc/withContext';
import { IBadgeItem } from '../../../../types/content';
import { getGiftBadges, getImage } from '../../../../utils/Functions';
import PictureImage from '../../../../utils/Image/PictureImage';
import Image from '../../../../utils/Image/Image';
import Fade from 'react-reveal/Fade';

interface IProgressBarProps {
  previousLoadPercentage: number;
  newLoadPercentage: number;
  currentBadge: number;
  badgeClick: (loadPercentage: string, index: number, userCancelledAnimation?: boolean) => void;
  context?: IContent;
}

const ProgressBarMobile = ({ previousLoadPercentage, newLoadPercentage, currentBadge, badgeClick, context }: IProgressBarProps) => {
  return (
    <ProgressBarMobileContainer>
      {/*Left side progress bar with icons start*/}
      <ProgressBarContainer>
        <ProgressBarItem previousHeight={previousLoadPercentage} newHeight={newLoadPercentage} />
      </ProgressBarContainer>
      <MobileSideBadgesContainer>
        {context.rewardBadge.badge.map((badgeItem: IBadgeItem, index) => {
          return (
            <React.Fragment key={'badge' + index}>
              <MobileSideBadgeImages highlightedBadge={currentBadge === index}
                                     onClick={() => badgeClick(badgeItem.loadPercentage, index, true)}
              >
                <Fade center distance={'20px'} delay={100 * index}>
                  <PictureImage
                    images={getImage(badgeItem.image + '_mobile', false)}
                    extension="png"
                    altText={badgeItem.image + '_mobile'}
                    className={[""]}
                  />
                </Fade>
              </MobileSideBadgeImages>
              {(index !== context.rewardBadge.badge.length - 1) && <MobileProgressSeparator />}
            </React.Fragment>
          );
        })}
      </MobileSideBadgesContainer>
      {/*Left side progress bar with icons start*/}
      {/*Right side badges start*/}
      <BadgeItemContainerMobile>
        <BadgeTopButtonMobile>{context.rewardBadge.badge[currentBadge].month}</BadgeTopButtonMobile>
        {context.rewardBadge.badge.map((badgeItem: IBadgeItem, index) => {
          return (
            <BigBadgeRewardContainer highlightedBadge={currentBadge === index} key={badgeItem.image}>
              <Image
                imageName={badgeItem.image}
                altText={badgeItem.badgeText}
                extension="png"
                className={['']}
              />
            </BigBadgeRewardContainer>
                )
            })}
          <BadgeBottomTextMobile>{context.rewardBadge.badge[currentBadge].badgeText}</BadgeBottomTextMobile>
          {/*Gift bottom icons*/}
          {context.rewardBadge.badge.map((badge : IBadgeItem, index) => {
            return (
              <GiftBadgeItemMobile highlightedBadge={currentBadge === index} key={'badge' + index}>
                <GiftIconMobile>{getGiftBadges(index + 1)}</GiftIconMobile>
                {/*Two description used to have a different cta singular text when there is only 1 reward*/}
                <GiftDescriptionMobile
                  dangerouslySetInnerHTML={{ __html: `<b>${(index + 1).toString()}</b> ${index === 0 ? context.rewardBadge.giftBadgeSingleDescription :
                      context.rewardBadge.giftBadgeDescription}` }} />
              </GiftBadgeItemMobile>);
          })}
        </BadgeItemContainerMobile>
      {/*Right side badges end*/}
    </ProgressBarMobileContainer>
  );
};
export default withContent(ProgressBarMobile);